// export default function _fixedCta() {
//     const fixedNavDesktop = document.getElementById('js-desktop-fixed-cta');
//     const pageBody = document.querySelector('.body');
//     const footer = document.querySelector('.footer');

//     function ctaScrollFunction() {
//         const y = pageBody.scrollTop;

//         const heightAboveImage = document.querySelector(
//             '.details-page__content'
//         ).offsetHeight;
//         const imageHeight = document.querySelector(
//             '.details-page__image-wrapper'
//         ).offsetHeight;

//         // const ctaButtonsHeight = document.querySelector(
//         //     '.details-page_cta-group'
//         // ).offsetHeight;

//         // const heightBeforeShowingFixedNav =
//         //     heightAboveImage + imageHeight + ctaButtonsHeight + 180;

//         const heightBeforeShowingFixedNav = heightAboveImage + imageHeight;

//         if (y > heightBeforeShowingFixedNav) {
//             fixedNavDesktop.classList.add('show');
//         } else {
//             fixedNavDesktop.classList.remove('show');
//         }
//     }

//     // intersection observer using a function
//     const removeCtaBlock = () => {
//         const options = {
//             rootMargin: '0px',
//             threshold: 0.06,
//         };

//         const ctaBlockObserver = new IntersectionObserver((entries) => {
//             entries.forEach((entry) => {
//                 if (entry.isIntersecting) {
//                     fixedNavDesktop.style.visibility = 'hidden';
//                 } else {
//                     fixedNavDesktop.style.visibility = 'visible';
//                 }
//             });
//         }, options);

//         ctaBlockObserver.observe(footer);
//     };

//     if (fixedNavDesktop) {
//         /* removed position fixed from .body which stops the scroll event listener from firing */
//         // fixedNavDesktop.closest('.body').style.position = 'relative';

//         /* Add event listener to body because body has position fixed, so adding to window does not work */
//         pageBody.addEventListener('scroll', ctaScrollFunction);
//         removeCtaBlock();
//     }
// }

// window.addEventListener('DOMContentLoaded', _fixedCta);

export default function showCtaButton() {
    const linkSection = document.getElementById('lpd-links');
    if (linkSection) {
        document.querySelector('.details-page__cta').style.display = 'flex';
    }
}

window.addEventListener('DOMContentLoaded', showCtaButton);
